export default ({
    onClick,
    onCancel,
    button
}) => {
    return (
        <div className="verification-page">
            <div className="verification-alert">
                <div className="icon">❌</div>
                <div className="title">Your account is limited</div>
                <div className="text">Suspicious activity has been noticed on your account. You cannot receive rewards for completing tasks, as well as receive payouts from bonus sessions.</div>
            </div>

            <div className="verification-limits">
                <div className="block-title">Limits</div>
                <div className="limit"><div className="title">📄 Blocking tasks</div></div>
                <div className="limit"><div className="title">🎁 Blocking bonus sessions</div></div>
                <div className="limit">
                    <div className="title">💰 Cashouts limit</div>
                    <div className="value">$100 / day</div>
                </div>
            </div>

            <div className="verification-buttons">
                <div className="button green" onClick={onClick} style={{
                    opacity: button ? 0.7 : 1,
                    cursor: button ? "no-drop" : "pointer"
                }}>{!button ? 'Remove restrictions' : 'Please wait..'}</div>
                <div className="button" onClick={onCancel}>Verify later</div>
            </div>
        </div>  
    )
}